import classNames from "classnames";
import styles from "./index.module.less";
import img1 from "./imgs/partner_1.png";
import img2 from "./imgs/partner_2.png";
import img3 from "./imgs/partner_3.png";
import img4 from "./imgs/partner_4.png";
import { useEffect, useRef } from "react";
import ArrowLeftIcon from "@/assets/imgs/arrow_left.svg?react";
import ArrowRightIcon from "@/assets/imgs/arrow_right.svg?react";
import dingdingIcon from "./imgs/dingding.svg";
import aliyunIcon from "./imgs/aliyun.svg";
import douyinIcon from "./imgs/douyin.svg";
import aofeiIcon from "./imgs/aofei.png";
import squareImg1 from "./imgs/1.png";
import squareImg2 from "./imgs/2.png";
import squareImg3 from "./imgs/3.png";
import squareImg4 from "./imgs/4.png";
import titleImg1 from "./imgs/title1.png";
import titleImg2 from "./imgs/title2.png";
import titleImg3 from "./imgs/title3.png";
import titleImg4 from "./imgs/title4.png";
import { Flex } from "antd";
import SVGIcon from "@/components/SVGIcon";

export const partnerList = [
  [
    {
      name: "阿里云",
      img: img1,
      squareImg: squareImg1,
      titleImg: titleImg1,
      icon: aliyunIcon,
      date: "2025-03-21",
      link: "https://mp.weixin.qq.com/s/K1Wi29mYZcM1e05M04raFA",
      subTitle: "小冰科技与阿里云深度合作 共筑金融行业数字员工解决方案",
      desc: `小冰科技与阿里云深度合作：基于多模态大模型技术，双方共建金融数字员工解决方案，聚焦智能交互、拟人互动、精准服务、效率革命、成本优化、数据安全六大方向，联合打造营销、审核、AI陪练等多个智能化产品；通义千问点金平台已集成小冰数字员工产品；阿里百炼平台也已上线小冰数字员工MCP服务，阿里云用户可便捷访问小冰的产品及服务。`,
    },
    {
      name: "抖音",
      img: img2,
      squareImg: squareImg2,
      titleImg: titleImg2,
      icon: douyinIcon,
      date: "2025-01-17",
      link: "https://mp.weixin.qq.com/s/MCVbxsTtfigAXV0Wg71iDw",
      subTitle: "小冰科技作为抖音AI分身专属服务商 拓展多领域智能应用场景",
      desc: "小冰科技作为抖音平台AI分身专属服务商提供AI互动营销解决方案，广泛覆盖地产、汽车、家装、电商等多个垂直领域，已成功服务万科、华润置地、瓜子二手车、美的集团等战略客户。作为火山引擎紧密交付伙伴，双方还联合打造了“数字员工+BI大屏”创新产品，为政企及园区提供AI数据分析解决方案，深度融合数据可视化与智能交互的全链路服务体验。",
    },
  ],
  [
    {
      name: "钉钉",
      img: img3,
      squareImg: squareImg3,
      titleImg: titleImg3,
      icon: dingdingIcon,
      date: "2024-01-10",
      link: "https://mp.weixin.qq.com/s/ZJTWHw3SwEQmjP1KFgDs3g",
      subTitle: "小冰科技与钉钉展开战略合作 让数字员工赋能千行百业",
      desc: "小冰科技与钉钉以AI技术为核心驱动力，共同推进企业数字化转型进程。双方联合研发的AI助理已登陆钉钉平台，依托小冰领先的数字员工技术与钉钉广泛的企业服务生态，目前在为近千家企业及学校用户提供智能化数字员工服务，在显著提升组织协同效率的同时，也极大改善了在线服务的响应速度。",
    },
    {
      name: "奥飞",
      img: img4,
      squareImg: squareImg4,
      titleImg: titleImg4,
      icon: aofeiIcon,
      date: "2025-07-17",
      link: "https://mp.weixin.qq.com/s/vWwCQFKnePVQF2brjoqcew",
      subTitle: "小冰科技与奥飞娱乐联合孵化打造交互式IP新物种",
      desc: "小冰科技与奥飞娱乐联手，专注于交互式IP创造领域，展开跨界创新。依托小冰科技全栈AI技术与奥飞娱乐覆盖全年龄段的IP矩阵，双方合作，致力于打破文化与科技的边界，打造融合二者的IP新物种，构建强大的交互式IP矩阵，为用户带来更具沉浸感、互动性的数字内容体验。",
    },
  ],
];
const PartnerCard = ({
  couple,
}: {
  couple: {
    name: string;
    desc: string;
    subTitle: string;
    img: string;
    icon: string;
    link?: string;
  }[];
}) => {
  return (
    <div className={styles.partnerCard}>
      {couple.map((partner, index) => (
        <div
          key={index}
          className={classNames(styles.partnerCardItem, {
            [styles.partnerCardItemFirst]: index === 0,
            [styles.partnerCardItemSecond]: index === 1,
          })}
          onClick={() => {
            if (partner.link) {
              window.open(partner.link, "_blank");
            }
          }}
        >
          <img className={styles.partnerCardImg} src={partner.img} />
          <div className={styles.partnerCardContent}>
            <Flex align="center" gap={".1rem"}>
              <img className={styles.partnerIcon} src={partner.icon} />
              <div className={styles.partnerTitle}>{partner.name}</div>
            </Flex>
            <div className={styles.partnerDesc}>
              <div
                style={{
                  fontSize: ".14rem",
                }}
              >
                {partner.subTitle}
              </div>
              <br />
              {partner.desc}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
const PartnerList = () => {
  const swiperRef = useRef<any>(null);
  useEffect(() => {
    const htmlFontSize = document.documentElement.style.fontSize;
    swiperRef.current = new window.Swiper(".partnerSwiper", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      spaceBetween: -20 / 100 * (parseFloat(htmlFontSize) || 16),
    });
  }, []);
  const handleNext = () => {
    swiperRef.current.slideNext();
  };
  const handlePrev = () => {
    swiperRef.current.slidePrev();
  };
  return (
    <div className={styles.partnerList}>
      <div className="swiper partnerSwiper">
        <div className="swiper-wrapper">
          {partnerList.map((partner, i) => (
            <div key={i} className={classNames("swiper-slide")}>
              <PartnerCard couple={partner} />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.pagination}>
        <div className={styles.prevBtn} onClick={handlePrev}>
          <SVGIcon icon={<ArrowLeftIcon />} />
        </div>
        <div className={styles.nextBtn} onClick={handleNext}>
          <SVGIcon icon={<ArrowRightIcon />} />
        </div>
      </div>
    </div>
  );
};
export default PartnerList;
